module.exports = __webpack_public_path__ + "assets/NametagParrot.4d06a05b.svg";